<template>
  <div class="document-field">
    <template v-if="screenMode === 'add'">
      <!-- <label class="vs-input--label"> {{ field.title }}</label> -->
      <vs-upload text="Enviar Arquivo" :fileName="'file'" multiple automatic :action="$store.state.auth.api_url + '/save-image'"
        :accept="accept"
        :data="{ application_token: $store.state.auth.app_token, session_token: $store.state.auth.token }" limit="20"
        @on-success="onSuccess($event, field.hash)" @on-delete="deleteDocument($event, field.hash)" />
    </template>
    <!-- single-upload  -->
    <template v-else-if="screenMode === 'edit' || screenMode === 'view'">
      <div class="vx-row">
        <div class="vx-col" v-for="file in fieldModel" v-if="!newDocuments.includes(file)" @click.stop="onOpenDocument($event, file)">
          <div>
            <div class="con-img-upload">
              <div class="img-upload">
                <button type="button" class="btn-x-file" @click="screenMode === 'edit' ? onClickClose(file) : null"><i translate="translate"
                    class="material-icons notranslate">clear</i></button>
                <h4 class="text-archive"><i translate="translate" class="material-icons notranslate">
                    description
                  </i><span>
                    Clique para visualizar o documento
                    <!-- {{ file }} -->
                  </span></h4>
              </div>
              <div class="con-input-upload disabled-upload upload-field-label">
                <input type="file" accept="all" disabled="disabled"><span class="text-input">Enviar
                  Arquivo</span>
                <span class="input-progress" style="width: 0%;"></span>
                <button type="button" disabled title="Upload" class="btn-upload-all vs-upload--button-upload"><i
                    translate="translate" class="material-icons notranslate">cloud_upload</i></button>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-col" v-if="screenMode === 'edit'">
          <vs-upload text="Enviar Arquivo" :fileName="'file'" multiple automatic :action="$store.state.auth.api_url + '/save-image'"
          :accept="accept"
          :data="{ application_token: $store.state.auth.app_token, session_token: $store.state.auth.token }" limit="20"
          @on-success="onSuccess($event, field.hash)" @on-delete="deleteDocument($event, field.hash)" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { props } from 'vue-prism-component';

export default {
  name: 'MultipleDocumentField',
  props: {
    field: {
      type: Object,
      required: true
    },
    screenMode: {
      type: String,
      default: 'view'
    },
    accept: {
      type: String,
      default: 'all'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    fieldModel: {
      type: Array,
      default: () => []
    },
    newDocuments: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    };
  },
  methods: {
    deleteDocument(event, fieldHash) {
      this.$emit('onDelete', event, fieldHash);
    },
    onSuccess(event, fieldHash) {
      this.$emit('onSuccess', event, fieldHash);
    },
    onOpenDocument(event, file) {
      this.$emit('onOpenDocument', {event, file});
    },
    onClickClose(file) {
      this.$emit('onClickClose', file);
    },
  },
  computed: {
    // Your computed properties go here
  },
  mounted() {
    console.log(this.viewMode);
    // Code to run when the component is mounted
  }
};
</script>

<style scoped>
.document-field {
  /* Your component styles go here */
}
</style>
